import { render, staticRenderFns } from "./ProductsCards.vue?vue&type=template&id=4d6f75a3"
import script from "./ProductsCards.vue?vue&type=script&lang=js"
export * from "./ProductsCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports